<template>
  <div class="all_body">
    <div class="marketinfo-body">
      <!-- iframe -->
      <div class="marketinfo-trend">
        <iframe :src="market" class="markerinfo-iframe"></iframe>
        <div class="marketinfo-line">
          <div class="marketinfo-fen"><div class="marketinfo_1">全国生猪价：</div><div class="marketinfo_line_1"></div></div>
          <div class="marketinfo-fen"><div class="marketinfo_1">河北石家庄：</div><div class="marketinfo_line_2"></div></div>
          <div class="marketinfo-fen"><div class="marketinfo_1">北京大洋路：</div><div class="marketinfo_line_3"></div></div>
          <div class="marketinfo-fen"><div class="marketinfo_1">山东德州：</div><div class="marketinfo_line_4"></div></div>
        </div>
        <div class="marketinfo-line">
          <div class="marketinfo-fen"><div class="marketinfo_1">上海禽蛋联盟：</div><div class="marketinfo_line_5"></div></div>
          <div class="marketinfo-fen"><div class="marketinfo_1">广州东莞信立：</div><div class="marketinfo_line_6"></div></div>
          <div class="marketinfo-fen"><div class="marketinfo_1">河南郑州：</div><div class="marketinfo_line_7"></div></div>
          <div class="marketinfo-fen"><div class="marketinfo_1">辽宁黑山：</div><div class="marketinfo_line_8"></div></div>
        </div>
      </div>

      <div class="marketinfo-content1">
        <el-tabs v-model="activeName" @tab-click="handleClick" >
          <el-tab-pane label="蛋价" name="first" ></el-tab-pane>
          <!-- <el-tab-pane label="淘汰鸡" name="second" ></el-tab-pane> -->
        </el-tabs>
        <div class="table_title1">
          <span class="area1">报价地区</span>
          <span class="sell1">规格</span>
          <span class="today1">今日</span>
          <span class="yesterday1">昨日</span>
          <span class="spread1">趋势</span>
        </div>
        <div class="marketinfo_list1">
          <div v-for="(items,index) in marketinfo_list" :key="index">
            <div class="con-str1">
              <img :src="star" />
              <span class="con-area1">{{items.province}}</span>
            </div>
            <ul v-for="(q,index) in items.list" :key="index" id="marketList">
              <li class="area1">{{q.area}}</li>
              <li class="sell1">{{q.shell_color}}{{q.weight}}</li>
              <li class="today1">{{q.today}}</li>
              <li class="yesterday1">{{q.yesterday}}</li>
              <li class="spread1">
                <div class="spread_type1_0" v-if="q.type == 0">± {{q.spread}}</div>
                <div class="spread_type1_1" v-else-if="q.type == 1">+ {{q.spread}}</div>
                <div class="spread_type1_2" v-else >- {{q.spread}}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="loadmore" @click="loadMore">点击加载更多</div>
      </div>
    </div>
  </div>
</template>

<script>
import { quotationLists, outQuotationLists } from "../api/api";
export default {
  name: "MarketInfo",
  data() {
    return {
      market: "https://api.rls.danjiguanjia.com/indexpc?type=month",
      star: "../static/img/star.jpg",
      activeName: "first",
      marketinfo_list: [],
      page1: 1,
      page2: 1
    };
  },
  mounted() {
    this.$store.commit("settab", 2);
    quotationLists({
      page: 1
    }).then(res => {
      this.marketinfo_list = res.data.lists;
      //console.log(res.data)
    });
  },

  methods: {
    handleClick(tab, event) {
      if (tab.name == "first") {
        quotationLists({
          page: 1
        }).then(res => {
          this.marketinfo_list = res.data.lists;
        });
      }
      if (tab.name == "second") {
        outQuotationLists({
          page: 1
        }).then(res => {
          this.marketinfo_list = res.data.lists;
          //console.log(res.data)
        });
      }
      this.activeName = tab.name;
    },
    loadMore() {
      if (this.activeName == "first") {
        this.page1++;
        quotationLists({
          page: this.page1
        }).then(res => {
          for (var i = 0; i < res.data.lists.length; i++) {
            this.marketinfo_list.push(res.data.lists[i]);
          }
        });
      }
      if (this.activeName == "second") {
        this.page2++;
        outQuotationLists({
          page: this.page2
        }).then(res => {
          for (var i = 0; i < res.data.lists.length; i++) {
            this.marketinfo_list.push(res.data.lists[i]);
          }
        });
      }
    }
  }
};
</script>

<style>
.all_body {
  width: 100%;
  padding-left: 11%;
  padding-right: 10%;
}
.marketinfo-body {
  margin: 0 auto;
  width: 1180px;
}
.marketinfo-trend {
  width: 1180px;
  height: 694px;
  background: #f8f8f8;
  padding: 6px;
  margin-top: 30px;
}
.markerinfo-iframe {
  width: 1160px;
  height: 573px;
  border: none;
  margin-bottom: 10px;
}
.marketinfo-content1 {
  margin-top: 65px;
  margin-bottom: 50px;
  width: 100%;
  color: #000000;
}
.marketinfo-content1 .el-tabs__item{
  font-size: 24px;
}
.marketinfo-content1 .el-tabs__item.is-active {
  color: #55B233;
}
.marketinfo-content1 .el-tabs__active-bar {
  background-color: #55B233;
}
.marketinfo-content1 .el-tabs__item:hover{
  color: #55B233 !important;
}
.table_title1 {
  display: flex;
  background: #DFDFDF;
  height: 30px;
  line-height: 30px;
  padding-left: 16px;
  margin-top: 23px;
}
.table_title1 span {
  height: 30px;
  line-height: 30px;
  font-size: 20px;
  color: #000000;
}
.area1 {
  text-align: left;
  width: 20%;
}
.sell1 {
  text-align: center;
  width: 20%;
}
.today1 {
  text-align: center;
  width: 25%;
}
.yesterday1 {
  text-align: center;
  width: 10%;
}
.spread1 {
  text-align: center;
  width: 25%;
}
.marketinfo_list1 ul {
  /* margin-top: 12px; */
  padding: 18px 0 10px 16px;
  border-bottom: 1px solid #d5d5d5;
  overflow: hidden;
}
.marketinfo_list1 ul li {
  float: left;
  color: #000000;
  list-style-type: none;
  font-size: 18px;
}
.spread_type1_0 {
  width: 100px;
  height: 30px;
  line-height: 30px;
  margin: 0 auto;
  font-size: 18px;
  color: #ffffff;
  background: #9F9F9F;
}
.spread_type1_1 {
  width: 100px;
  height: 30px;
  line-height: 30px;
  margin: 0 auto;
  font-size: 18px;
  color: #ffffff;
  background: #FB0000;
}
.spread_type1_2 {
  width: 100px;
  height: 30px;
  line-height: 30px;
  margin: 0 auto;
  font-size: 18px;
  color: #ffffff;
  background: #22AC38;
}
.con-str1 {
  margin-top: 15px;
  margin-left: 8px;
  font-weight: bold;
  margin-bottom: 5px;
}
.con-area1{
  font-size: 22px;
  margin-top: 38px;
}
.con-str1 img {
  width: 15px;
  height: 15px;
}
.loadmore {
  width: 80%;
  text-align: center;
  color: #000000;
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  margin-top: 20px;
  cursor: pointer;
}
.marketinfo-line{
  display: flex;
  width: 1160px;
  margin-top: 20px;
  height: 20px;
  line-height: 20px;
  font-size: 20px;
}
.marketinfo-fen{
  width: 100%;
  display: flex;
  margin-left: 10px;
}
.marketinfo_1{
  margin-left: 13px;
  cursor: pointer;
}
.marketinfo_line_1{
  width: 80px;
  height: 5px;
  background: #FB0000;
  margin-left: 22px;
  margin-top: 10px;
}
.marketinfo_line_2{
  width: 80px;
  height: 3px;
  background: #008000;
  margin-left: 30px;
  margin-top: 10px;
}
.marketinfo_line_3{
  width: 80px;
  height: 3px;
  background: #00FFFF;
  margin-left: 5px;
  margin-top: 10px;
}
.marketinfo_line_4{
  width: 80px;
  height: 3px;
  background: #FF33FF;
  margin-left: 5px;
  margin-top: 10px;
}
.marketinfo_line_5{
  width: 80px;
  height: 3px;
  background: #FFFF00;
  margin-left: 2px;
  margin-top: 10px;
}
.marketinfo_line_6{
  width: 80px;
  height: 3px;
  background: #800080;
  margin-left: 10px;
  margin-top: 10px;
}
.marketinfo_line_7{
  width: 80px;
  height: 3px;
  background: #FF6600;
  margin-left: 25px;
  margin-top: 10px;
}
.marketinfo_line_8{
  width: 80px;
  height: 3px;
  background: #0000FF;
  margin-left: 5px;
  margin-top: 10px;
}
#marketList:nth-of-type(even){
  background:#F9F9F9;
}/*偶数行*/
</style>



// WEBPACK FOOTER //
// src/components/MarketInfo.vue